var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49912 6C7.49912 4.80653 7.97323 3.66193 8.81714 2.81802C9.66105 1.97411 10.8056 1.5 11.9991 1.5C13.1926 1.5 14.3372 1.97411 15.1811 2.81802C16.025 3.66193 16.4991 4.80653 16.4991 6C16.4991 7.19347 16.025 8.33807 15.1811 9.18198C14.3372 10.0259 13.1926 10.5 11.9991 10.5C10.8056 10.5 9.66105 10.0259 8.81714 9.18198C7.97323 8.33807 7.49912 7.19347 7.49912 6ZM3.75012 20.105C3.78384 17.9395 4.66776 15.8741 6.21108 14.3546C7.7544 12.8351 9.83333 11.9834 11.9991 11.9834C14.1649 11.9834 16.2438 12.8351 17.7872 14.3546C19.3305 15.8741 20.2144 17.9395 20.2481 20.105C20.2507 20.2508 20.2108 20.3942 20.1332 20.5176C20.0555 20.641 19.9436 20.7392 19.8111 20.8C17.3603 21.9237 14.6953 22.5037 11.9991 22.5C9.21312 22.5 6.56612 21.892 4.18712 20.8C4.05461 20.7392 3.94269 20.641 3.86508 20.5176C3.78747 20.3942 3.74752 20.2508 3.75012 20.105Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/Edit Profile.6e8ca54dc20562bf608bfb62c3f5ad18.svg";
export { ForwardRef as ReactComponent };